import { createUseStyles } from 'react-jss'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles(
  (theme: Theme) => ({
    control: {
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      '& g path': {
        fill: theme.palette.primary.main,
      },
      '& rect': {
        stroke: theme.palette.primary.main,
      },
      '&:active': {
        '&:not($controlLastPeriod)': {
          '& g path': {
            fill: theme.palette.common.white,
          },

          '& g rect': {
            fill: theme.palette.primary.main,
          },

          '& rect': {
            stroke: theme.palette.common.white,
          },
        },
      },
    },
    controlLastPeriod: {
      cursor: 'default',
      '& g path': {
        fill: theme.palette.grey['400'],
      },

      '& g rect': {
        fill: 'transparent',
      },

      '& rect': {
        stroke: theme.palette.grey['400'],
      },
    },
    controlLast: {
      opacity: 0.2,
    },

    backArrowWeekdayView: {
      display: 'initial',
      position: 'absolute',
      left: -30,

      [forTabletPortraitUp]: {
        left: -40,
      },

      [forPhoneOnly]: {
        left: 0,
        top: -28,
      },
    },

    nextArrowWeekdayView: {
      display: 'initial',
      position: 'absolute',
      right: -30,

      [forTabletPortraitUp]: {
        right: -40,
      },
      [forPhoneOnly]: {
        right: 0,
        top: -28,
      },
    },
  }),
  { name: 'PeriodRange' }
)
